import {Stack, Typography} from '@mui/material';
import React from 'react';

import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {AlertModal, CTAButtonFixed} from 'presentation/components';
import {BookingEmptyState} from 'presentation/modules/booking/shared/ui/components/BookingEmptyState';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {BookingNotFoundVariantEnum} from 'presentation/modules/booking/shared/ui/components/BookingNotFoundDialog/types';
import {BookingNotFoundListCard} from 'presentation/modules/booking/shared/ui/components/BookingNotFoundListCard';
import {DistrictList} from 'presentation/modules/booking/shared/ui/components/DistrictList';

import {translations} from 'presentation/translations-new';
import {ExamDistrictNotFoundState} from './components/ExamDistrictNotFoundState';
import {useExamDistrictSelection} from './hooks/useExamDistrictSelection';
import {DistrictsProps} from './types';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const {
	loadingError,
	loadingState,
	emptySearchState,
	notFoundModal: {cardListText},
	emptyModal: {part1, part2},
} = translations['pt-br'].privateFlow.bookingFlow.districtFlow;
const {goForward, notice, understood} = translations['pt-br'].commons;

export function ExamDistrictSelection({handleNextStep}: DistrictsProps) {
	const {
		districtListIsLoading,
		districtListHasError,
		districtListHasUnprocessableError,
		refetch,
		showNotFoundState,
		showEmptyState,
		filteredDistrictList,
		handleSelectCard,
		selectedDistricts,
		handleGoForward,
		showEmptyDistrictsModal,
		setShowEmptyDistrictsModal,
	} = useExamDistrictSelection({handleNextStep});

	if (districtListHasError && !districtListHasUnprocessableError) {
		return (
			<BookingErrorState
				showHeader={false}
				errorTitle={loadingError}
				handleRefresh={refetch}
			/>
		);
	}

	if (districtListIsLoading) {
		return <BookingLoadingState showHeader={false} loadingText={loadingState} />;
	}

	if (showNotFoundState) {
		return <ExamDistrictNotFoundState />;
	}

	if (showEmptyState) {
		return (
			<BookingEmptyState
				description={emptySearchState.emptyDistrictAll}
				flowType={FlowEnum.EXAM}
				dataTagId={FinishWithoutCompleteFlowEnum.SEM_BAIRRO_ENCONTRADO}
			/>
		);
	}

	return (
		<Stack gap={2}>
			<DistrictList
				list={filteredDistrictList}
				handleSelectCard={handleSelectCard}
				selectedDistricts={selectedDistricts}
			/>
			<Stack mt={2} id="go-forward-button">
				<BookingNotFoundListCard
					flowType={FlowEnum.EXAM}
					customOrientationText={cardListText}
					variant={BookingNotFoundVariantEnum.DISTRICT}>
					<CTAButtonFixed.Root>
						<CTAButtonFixed.Action fullWidth onClick={handleGoForward} size="large">
							{goForward}
						</CTAButtonFixed.Action>
					</CTAButtonFixed.Root>
				</BookingNotFoundListCard>
			</Stack>

			{showEmptyDistrictsModal ? (
				<AlertModal
					open={showEmptyDistrictsModal}
					headerTitle={notice}
					variant="info"
					onClose={() => setShowEmptyDistrictsModal(false)}
					buttonLabel={understood}
					slotProps={{
						paper: {
							style: {
								maxWidth: 420,
								width: '100%',
							},
						},
					}}
					subDescription={
						<Typography variant="h6" fontSize={18} textAlign="center" fontWeight={600}>
							{part1} <br /> {part2}
						</Typography>
					}
				/>
			) : null}
		</Stack>
	);
}
